import React from "react";
import CardWithBorder from "../../newComponent/NewCardsComp/CardWithBorder";
import { Grid, Paper, Typography, Box } from "@mui/material";
import InputField from "../../newComponent/themeprovider/textField/InputFiledComp";
import CustomNewButton from "../../newComponent/themeprovider/button/CustomNewButton";
import ReactQuill from "react-quill";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ font: [] }, { size: [] }],

    ["bold", "italic", "underline", "strike"],

    [{ color: [] }, { background: [] }],

    [{ script: "sub" }, { script: "super" }],

    [{ header: 1 }, { header: 2 }, "blockquote", "code-block"],

    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],

    [{ direction: "rtl" }, { align: [] }],

    ["link", "image", "video"],

    ["clean"],
  ],
};

const formats = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "direction",
  "align",
  "link",
  "image",
  "video",
];

export default function EditMode({
  currentLesson,
  handleChange,
  handleSaveDay,
  handleDeleteFile,
  handleUploadFiles, // 👈 receive here
}) {
  return (
    <CardWithBorder>
      <Grid container spacing={2}>
        <InputField
          label="Topic"
          value={currentLesson.topic}
          onChange={(e) => handleChange("topic", e.target.value)}
          isRequired
        />

        <InputField
          label="Objective"
          value={currentLesson.objective}
          onChange={(e) => handleChange("objective", e.target.value)}
          isRequired
        />

        <Grid item xs={12}>
          <Typography>
            Content <span style={{ color: "red" }}>*</span>
          </Typography>

          <ReactQuill
            value={currentLesson.content}
            onChange={(v) => handleChange("content", v)}
            modules={modules}
            formats={formats}
            theme="snow"
            placeholder="Write lesson content here..."
          />
        </Grid>

        <InputField
          label="Activity"
          value={currentLesson.activity}
          onChange={(e) => handleChange("activity", e.target.value)}
          isRequired
        />

        <InputField
          label="Remarks"
          value={currentLesson.remarks}
          onChange={(e) => handleChange("remarks", e.target.value)}
        />

        <Grid item xs={12} textAlign="end">
          <CustomNewButton label="Save" onClick={handleSaveDay} />
        </Grid>

        <Grid item xs={12}>
          <Accordion
            defaultExpanded={true} // open by default (optional)
            sx={{
              borderRadius: 2,
              boxShadow: "none",
              border: "1px solid #e0e0e0",
              "&:before": { display: "none" },
            }}
          >
            {/* Header */}
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={600}>📎 Add Attachments</Typography>
            </AccordionSummary>

            {/* Body */}
            <AccordionDetails>
              <Grid container spacing={4}>
                {/* Study Material */}
                <Grid item xs={12} md={6}>
                  <Typography mb={1}>Study Material </Typography>

                  <Paper
                    variant="outlined"
                    component="label"
                    sx={{
                      p: 3,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                      textAlign: "center",
                      borderStyle: "dashed",
                      borderWidth: "2px",
                      borderColor: "primary.main",
                      borderRadius: 2,
                      bgcolor: "#f9fff9",
                      cursor: "pointer",
                      width: "100%",
                      minHeight: "140px",
                      "&:hover": {
                        bgcolor: "#ecf7ee",
                      },
                    }}
                  >
                    <CloudUploadIcon color="primary" sx={{ fontSize: 48 }} />

                    <Typography fontWeight={600}>Click to Upload</Typography>

                    <Typography variant="body2" color="text.secondary">
                      WORD / PDF
                    </Typography>

                    <input
                      type="file"
                      hidden
                      multiple
                      accept=".pdf,.doc,.docx"
                      // onChange={(e) => {
                      //   const files = Array.from(e.target.files);

                      //   handleChange("study_material", [
                      //     ...(currentLesson.study_material || []),
                      //     ...files,
                      //   ]);
                      // }}

                      onChange={async (e) => {
                        const file = e.target.files[0];

                        if (!file) return;

                        // Upload using file directly ✅
                        await handleUploadFiles(null, file, "study_material");

                        e.target.value = "";
                      }}
                    />
                  </Paper>

                  {/* Preview */}
                  {currentLesson.study_material?.length > 0 && (
                    <Box mt={2}>
                      <Paper
                        elevation={1}
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                        }}
                      >
                        <Typography mb={2} sx={{ textDecoration: "underline" }}>
                          Uploaded Files
                        </Typography>
                        {currentLesson.study_material.map((file, index) => {
                          const fileName = file?.name || file?.original_filename;

                          return (
                            <>
                              <Box
                                key={index}
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={2}
                              >
                                {/* Left Side */}
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={1}
                                  sx={{
                                    flex: 1,
                                    minWidth: 0, // 🚨 MOST IMPORTANT
                                  }}
                                >
                                  <InsertDriveFileIcon color="primary" />

                                  <Typography
                                    variant="body2"
                                    sx={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {fileName}
                                  </Typography>
                                </Box>

                                {/* Delete */}
                                <DeleteIcon
                                  color="error"
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleDeleteFile(
                                      "study_material",
                                      file.original_filename || file.name,
                                    );
                                  }}
                                />
                              </Box>
                            </>
                          );
                        })}
                      </Paper>
                    </Box>
                  )}
                </Grid>

                {/* Presentation */}
                <Grid item xs={12} md={6}>
                  <Typography mb={1}>Presentation </Typography>

                  <Paper
                    variant="outlined"
                    component="label"
                    sx={{
                      p: 3,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                      textAlign: "center",
                      borderStyle: "dashed",
                      borderWidth: "2px",
                      borderColor: "primary.main",
                      borderRadius: 2,
                      bgcolor: "#f9fff9",
                      cursor: "pointer",
                      width: "100%",
                      minHeight: "140px",
                      "&:hover": {
                        bgcolor: "#ecf7ee",
                      },
                    }}
                  >
                    <CloudUploadIcon color="primary" sx={{ fontSize: 48 }} />

                    <Typography fontWeight={600}>Click to Upload</Typography>

                    <Typography variant="body2" color="text.secondary">
                      PPT / PPTX
                    </Typography>

                    <input
                      type="file"
                      hidden
                      multiple
                      accept=".ppt,.pptx"
                      onChange={async (e) => {
                        const file = e.target.files[0];

                       
                          await handleUploadFiles(
                            file,
                            null,
                            "presentation_file",
                          );
                        

                        e.target.value = "";
                      }}
                    />
                  </Paper>

                  {/* Preview */}
                  {currentLesson.presentation_files?.length > 0 && (
                    <Paper
                      elevation={1}
                      sx={{ mt: 2, p: 1.5, borderRadius: 2 }}
                    >
                      <Typography mb={2} sx={{ textDecoration: "underline" }}>
                        Uploaded Presentations
                      </Typography>

                      {currentLesson.presentation_files.map((file, index) => {
                        const fileName = file?.name || file?.original_filename;

                        return (
                          <Box
                            key={index}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={2}
                          >
                            <Box display="flex" alignItems="center" gap={1}>
                              <InsertDriveFileIcon color="error" />
                              <Typography variant="body2" noWrap>
                                {fileName}
                              </Typography>
                            </Box>

                            <DeleteIcon
                              color="error"
                              sx={{ cursor: "pointer" }}
                              onClick={() =>
                                handleDeleteFile("presentation_file", fileName)
                              }
                            />
                          </Box>
                        );
                      })}
                    </Paper>
                  )}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </CardWithBorder>
  );
}
